import { render, staticRenderFns } from "./ToDoCalendar.vue?vue&type=template&id=28a4882c&"
import script from "./ToDoCalendar.vue?vue&type=script&lang=js&"
export * from "./ToDoCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ToDoCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports